import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px;
  /* width: 200px; */
`

export const ItemWrapper = styled.div`
  display: flex;
  /* flex-direction: column; */
  margin: 0 40px 20px 0;
  align-items: center;
`
